import { Trans } from "translations";
import { Checkbox } from "ui-kit/Checkbox";
import { FlexRow } from "ui-kit/Layout/Flex";
import { Typography } from "ui-kit/Typography";
import styles from "./AcceptBox.module.css";

type AcceptBoxProps = {
  onSelect: () => void;
  selected: boolean;
  textKey: string;
  links: string[];
};

const AcceptBox = ({ onSelect, selected, textKey, links }: AcceptBoxProps) => (
  <FlexRow
    justifyContent="space-between"
    className={styles.acceptBox}
    onClick={onSelect}
  >
    <div className={styles.acceptBoxCheckbox}>
      <Checkbox active={selected} />
    </div>
    <Typography variant="body3">
      <Trans
        i18nKey={textKey}
        components={links.map((href) => (
          <a
            key={0}
            className={styles.acceptBoxLink}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
          />
        ))}
      />
    </Typography>
  </FlexRow>
);

export default AcceptBox;
